var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import Button from "antd/es/button";
import "antd/es/button/style/index.js";
let AbfragerMemorizePointsRevealButtons = class AbfragerMemorizePointsRevealButtons extends React.PureComponent {
    render() {
        const { question } = this.props;
        return null;
        return (React.createElement("div", { style: { display: 'flex', marginTop: 10, marginBottom: 10 } },
            React.createElement(Button, { type: "dashed", block: true, style: { marginLeft: 20, marginRight: 10 }, onClick: question.memorizePointsReveal.revealOnePoint }, "Einen Punkt aufdecken"),
            React.createElement(Button, { type: "default", block: true, style: { marginRight: 20, marginLeft: 10 }, onClick: question.memorizePointsReveal.revealAllPoints }, "Alles aufdecken")));
    }
};
AbfragerMemorizePointsRevealButtons = __decorate([
    observer
], AbfragerMemorizePointsRevealButtons);
export { AbfragerMemorizePointsRevealButtons };
